module.exports = __webpack_public_path__ + "static/media/retweet.bb855c0b.svg";